import React from "react";
import { SxProps, TablePagination, Theme } from "@mui/material";
import TablePaginationActions from "../ActionsComponent";

export interface PaginationBarProps {
  /** Total de itens. Em modo servidor passa `total`; em modo cliente passa `data.length`. */
  count: number;
  /** Página atual (0-based, padrão react-table). */
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  /**
   * Quando preenchido indica paginação controlada pelo servidor.
   * Usado para calcular o intervalo exibido no label (ex.: "10 - 20 de 100").
   */
  givenPage?: number;
  /** Total real de registros no servidor, necessário com `givenPage`. */
  total?: number;
  /** Estilos adicionais repassados ao TablePagination do MUI. */
  sx?: SxProps<Theme>;
}

/**
 * Barra de paginação centralizada para tabelas baseadas em react-table.
 * Suporta modo cliente (sem `givenPage`) e modo servidor (com `givenPage` + `total`).
 */
export function PaginationBar({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  givenPage,
  total,
  sx,
}: PaginationBarProps) {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      sx={{
        ".MuiTablePagination-spacer": { display: "none" },
        ".MuiTablePagination-toolbar": { padding: "0 3px" },
        ...sx,
      }}
      onPageChange={(_, newPage) => onPageChange(newPage)}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[5, 10, 20, 50, 100]}
      labelRowsPerPage="Linhas por página"
      labelDisplayedRows={({ from, to, count: c }) => {
        if (givenPage !== undefined && rowsPerPage && total) {
          const serverFrom = givenPage * rowsPerPage + 1;
          const serverTo = Math.min(givenPage * rowsPerPage + rowsPerPage, total);
          return `${serverFrom} - ${serverTo} de ${total}`;
        }
        return `${from} - ${to} de ${c}`;
      }}
      onRowsPerPageChange={(e) => onRowsPerPageChange(Number(e.target.value))}
      ActionsComponent={TablePaginationActions}
    />
  );
}

export default PaginationBar;
